import { createBehavior } from '@area17/a17-behaviors';
import Swiper, { Controller, EffectFade, Navigation } from 'swiper';

import { createScale } from '../utils/scale';

import 'swiper/css';
import 'swiper/css/effect-fade';

const imageSlideshow = createBehavior(
  'imageslideshow',
  {
    setGapFromSensor() {
      const sensorStyle = window.getComputedStyle(this.$sensor);
      const width = parseInt(sensorStyle.getPropertyValue('width'), 10);
      const marginLeft = parseInt(
        sensorStyle.getPropertyValue('margin-left'),
        10
      );
      const marginRight = parseInt(
        sensorStyle.getPropertyValue('margin-right'),
        10
      );
      this.gap = marginLeft;

      if (this.swiper) {
        this.swiper.params.spaceBetween = this.gap;
        this.swiper.update();
      }
    },
    onWindowResize() {
      this.setGapFromSensor();
    },

    getTransitionSpeed() {
      const transitionSpeed = this.currentTransitionSpeed;
      // don't forget to reset the variable for future calls
      this.currentTransitionSpeed = 0;
      return transitionSpeed;
    },

    getActiveIndexBeforeTransitionStart(swiper, slides) {
      const isDragging = !Math.abs(slides[swiper.activeIndex].progress === 1);
      if (isDragging) {
        return swiper.slidesGrid.indexOf(
          -swiper.touchEventsData.startTranslate || swiper.params.initialSlide
        );
      } else {
        return swiper.activeIndex;
      }
    },

    getDirection(animationProgress) {
      if (animationProgress === 0) {
        return 'NONE';
      } else if (animationProgress > 0) {
        return 'NEXT';
      } else {
        return 'BACK';
      }
    },
  },
  {
    init() {
      const imageSlideshow = this;
      this.$sensor = this.getChild('sensor');
      this.$inner = this.getChild('inner');
      this.$text = this.getChild('text');

      this.setGapFromSensor();

      this.textSwiper = new Swiper(this.$text, {
        modules: [EffectFade],
        effect: 'fade',
        speed: 300,
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
        loop: false,
        allowTouchMove: false,
      });

      this.swiper = new Swiper(this.$inner, {
        modules: [Controller, Navigation],
        slidesPerView: 1,
        spaceBetween: this.gap,
        grabCursor: true,
        on: {
          afterInit: () => {
            setTimeout(() => {
              this.$node.classList.add('is-ready');
            }, 100);
          },
        },
        navigation: {
          nextEl: this.getChild('next-btn'),
          prevEl: this.getChild('prev-btn'),
        },
      });

      this.swiper.controller.control = this.textSwiper;

      this.swiper.on('progress', function (swiper, progress) {
        const percPerSlide = 1 / (swiper.slides.length - 1);
        const scaleScale = createScale({
          domain: [0, percPerSlide],
          range: [1, 0.614],
        });
        for (let i = 0; i < swiper.slides.length; i++) {
          const progressForSlide = percPerSlide * i;
          const distanceFromProgress = Math.abs(progress - progressForSlide);
          const clamped = Math.min(
            percPerSlide,
            Math.max(0, distanceFromProgress)
          );
          swiper.slides[i].querySelector(
            '.c-image-slideshow__item-inner'
          ).style.transform = `scale(${scaleScale(clamped)})`;
        }
      });
      this.swiper.on('slideChange', function () {
        imageSlideshow.getChild('index').innerText = (
          imageSlideshow.swiper.activeIndex + 1
        )
          .toString()
          .padStart(2, '0');
      });
      window.addEventListener('resize', this.onWindowResize);
    },
    destroy() {
      window.removeEventListener('resize', this.onWindowResize);
      this.swiper.destroy();
    },
  }
);

export default imageSlideshow;
